import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {AuthService} from '../../../../../services/auth/auth.service';
import {BotPrompt} from '../../../../../models/bot-prompt';
import {BotPromptService} from '../../../../../services/bot-prompt/bot-prompt.service';
import {MetaTitle} from '../../../../../decorator/meta-title';

@Component({
  selector: 'app-bot-prompt-form',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterLink
  ],
  templateUrl: './bot-prompt-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bot-prompt-form.component.scss'
})
@MetaTitle('Bot Prompt Form')
export class BotPromptFormComponent implements OnInit {

  botPrompt: BotPrompt | null = null;

  form = new FormGroup({
    name: new FormControl('', Validators.required),
    prompt: new FormControl('', Validators.required),
  });

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private dialog: DialogService,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private botPromptService: BotPromptService,
  ) {
  }

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));

    if (id) {
      this.loader.startLoading();

      this.botPromptService.findOneById(id).subscribe((botPrompt: BotPrompt) => {
        this.botPrompt = botPrompt;
        this.form.patchValue({
          name: this.botPrompt.name,
          prompt: this.botPrompt.prompt,
        });

        this.loader.stopLoading();
      });
    }
  }

  onSubmit(): void {
    if (!this.form.valid) {
      return;
    }

    this.loader.startLoading();

    let params: any = this.form.value;

    if (this.isCreate()) {
      this.botPromptService.create(params).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Bot prompt has been created.');
        this.router.navigateByUrl('/translation/bot-prompts').then();
      });
    } else if (this.botPrompt?.id) {
      this.botPromptService.update(this.botPrompt.id, params).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Bot prompt has been modified.');
        this.router.navigateByUrl('/translation/bot-prompts').then();
      });
    }
  }

  isCreate(): boolean {
    return !this.botPrompt;
  }

  canUpdate(): boolean {
    return this.auth.hasRolesSync(['ROLE_API_TRANSLATION_WRITE']);
  }
}
